export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Boiler room and plant utility technicians and operators, mechanical and instrumentation maintenance technicians, plant, process and energy engineers, HVAC and energy technicians, and technical students.',
  ],
  ['Content depth?', 'From heat and steam fundamentals to boiler operation, heat exchanger performance, inspection, maintenance and troubleshooting.'],
  [
    'Is this a certification or licence course?',
    'No. It is an educational technical reference in PDF format. It does not grant any certification or licence.',
  ],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow local codes, site procedures and manufacturer instructions.',
  ],
  ['Format?', 'Professional PDF files with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
